export enum actionTypes {
    FINISH_LAUNCH_PROCESS = 'GAME_LAUNCH:LAUNCH:FINISH',
    START_LAUNCH_PROCESS = 'GAME_LAUNCH:LAUNCH:START',
    UPDATE_LAUNCH_STAGE = 'GAME_LAUNCH:STAGE:UPDATE'
}
